import "./index.css";
import MaintenanceImg from "/src/assets/images/camion_salmones_500.jpg";

export default function Error404() {
  return (
    <div style={{ margin: "50px" }}>
      <h1>ERROR 404</h1>
      <div className="wrap">
        <img width="1000px" height="600px" src={MaintenanceImg} />
        <h2>
          <p style={{ fontSize: "16px" }}>
            ¡Oopps! Lo sentimos, no se ha podido completar la entrega
            solicitada, al parecer la página no existe.
          </p>
        </h2>
        <p style={{ fontSize: "12px" }}>
          Comunícate con soporte, después de revisar y confirmar que la url es
          la correcta.
        </p>
      </div>
    </div>
  );
}
